export default {
  thor: {
    moduleCode: {
      production: "SUB_STORMBORN",
      development: "SUB_STORMBORN",
    },
    programId: null,
  },
  api: {
    cognito: {
      production: {
        api: {
          invokeUrl:
            "https://5bltcq602h.execute-api.us-west-2.amazonaws.com/prod",
        },
        cognito: {
          // test
          // region: 'us-east-1',
          // user_pool_id: 'us-east-1_SLhzeyF6G',
          // app_client_id: '7aobf41shq9j1jf69ckicbhp2k',
          // actual
          // region: "ap-southeast-2",
          // user_pool_id: "ap-southeast-2_wtuzQu1Rv",
          // app_client_id: "1gu1kkpaa215f81tein83jnqtn",
          region: "eu-west-1",
          user_pool_id: "eu-west-1_Uuq4UjsMz",
          app_client_id: "5ijfkh97pk18pn1hosksd0c5oh",
        },
      },
      development: {
        api: {
          invokeUrl:
            "https://5bltcq602h.execute-api.us-west-2.amazonaws.com/prod",
        },
        cognito: {
          // test
          // region: 'us-east-1',
          // user_pool_id: 'us-east-1_SLhzeyF6G',
          // app_client_id: '7aobf41shq9j1jf69ckicbhp2k',
          // actual
          // region: "ap-southeast-2",
          // user_pool_id: "ap-southeast-2_wtuzQu1Rv",
          // app_client_id: "1gu1kkpaa215f81tein83jnqtn",

          region: "eu-west-1",
          user_pool_id: "eu-west-1_Uuq4UjsMz",
          app_client_id: "5ijfkh97pk18pn1hosksd0c5oh",
        },
      },
    },
    login: {
      url: {
        production:
          "https://5fj7g7llff.execute-api.ap-southeast-2.amazonaws.com/production/stormborn-gui-strapi-authorization-live",
        development:
          "https://5fj7g7llff.execute-api.ap-southeast-2.amazonaws.com/production/stormborn-gui-strapi-authorization-live",
      },
    },
    gui: {
      url: {
        production: "https://thq-stormborn-gui.tr4ns.com",
        development: "https://thq-stormborn-gui.tr4ns.com",
      },
    },
    logger: {
      url: {
        production:
          "https://mm7vd2m953.execute-api.ap-southeast-2.amazonaws.com/test/",
        development:
          "https://mm7vd2m953.execute-api.ap-southeast-2.amazonaws.com/test/",
      },
    },
    tranxactor: {
      url: {
        production: "https://rewards.subway.co.uk/tx-auth",
        development: "https://rewards.subway.co.uk/tx-auth",
      },
    },
    alias: {
      url: {
        production: "https://ro-payment-card-alias.tranxactor.com",
        development: "https://ro-payment-card-alias.tranxactor.com",
      },
    },
    cms: {
      url: {
        // production:
        //   'http://ec2-54-194-138-98.eu-west-1.compute.amazonaws.com:1337',
        // development:
        //   'http://ec2-54-194-138-98.eu-west-1.compute.amazonaws.com:1337',
        production: "https://strapi-sub.tranxactor.com",
        development: "https://strapi-sub.tranxactor.com",
      },
    },
    stormborn: {
      url: {
        production: "https://rewards.subway.co.uk/tx-auth",
        development: "https://rewards.subway.co.uk/tx-auth",
        mockapi: "https://rewards.subway.co.uk/mobilegateway",
        api: "https://rewards.subway.co.uk/tx-sub",
      },
    },
    subcard: {
      url: {
        production: "https://rewards.subway.co.uk",
        development: "https://rewards.subway.co.uk",
      },
    },
    subway: {
      url: {
        production: "https://subway.tranxactor.com",
        development: "https://subway.tranxactor.com",
      },
    },
  },
};
